export * from '@fhs/routing/src/routes/rewards/list/[rewardId]';
export { default } from '@fhs/routing/src/routes/rewards/list/[rewardId]';
